module.exports = __webpack_public_path__ + "static/assets/88727f206ee026a526b87535e352da55.png";